module.exports = __webpack_public_path__ + "media/images/facebook-omni-7faabd062dddda423c1889abba32f58b.svg";